import { render, staticRenderFns } from "./PaymentSuccessDialog.vue?vue&type=template&id=23af1e46&scoped=true"
import script from "./PaymentSuccessDialog.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessDialog.vue?vue&type=style&index=0&id=23af1e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af1e46",
  null
  
)

export default component.exports